<template>
  <div class="container py-16 print:py-0">
    <d-table class="pt-5" :loading="loadingTransactions" :data="transactions" detailed paginated backend-pagination :total="total" striped :per-page="pagination.pageSize" default-sort-direction="desc" backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" :search.sync="filter" show-search @page-change="page => pagination.page = page" @sort="onSort">
      <template #action-buttons>
        <h1 class="text-primary-500 mr-3 mb-0">
          Transactions
        </h1>
      </template>

      <template slot-scope="props">
        <d-table-column field="nameOnCard" label="Name on Card" :row="props.row" sortable />
        <d-table-column field="type" label="Type" sortable>
          {{ getFriendlyTypeName(props.row.type) }}
        </d-table-column>
        <d-table-column field="orderNumber" label="Order Number" :row="props.row" sortable />
        <d-table-column field="companyName" label="Company Name" :row="props.row" sortable />
        <d-table-column field="billingStatus" label="Status" :row="props.row" centered sortable>
          <div class="flex justify-center">
            <d-chip :color="getStatusColor(props.row.billingStatus)" class="whitespace-no-wrap">
              {{ props.row.billingStatus }}
            </d-chip>
          </div>
        </d-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <div class="flex flex-center">
          <div class="w-full">
            <h3>Payment Processor Status</h3>
            <p>{{ props.row.billingStatusDescription }}</p>
          </div>
          <div class="w-full md:w-1/2">
            <h3>Billing Information</h3>
            <p v-if="props.row.billingAddress1">
              Address1: {{ props.row.billingAddress1 }}
            </p>
            <p v-if="props.row.billingAddress2">
              Address2: {{ props.row.billingAddress2 }}
            </p>
            <p v-if="props.row.billingCity">
              City: {{ props.row.billingCity }}
            </p>
            <p v-if="props.row.billingStateProvince">
              State: {{ props.row.billingStateProvince }}
            </p>
            <p v-if="props.row.BillingZip">
              Zip/Postal Code: {{ props.row.BillingZip }}
            </p>
          </div>
          <div class="w-full md:w-1/2">
            <h3>Contact Information</h3>
            <p>Name: {{ props.row.nameOnCard }}</p>
            <p v-if="props.row.companyName">
              Company Name: {{ props.row.companyName }}
            </p>
            <p>
              Email: {{ props.row.billingEmail }}
            </p>
            <p>
              Phone: {{ props.row.billingPhone }}
            </p>
          </div>
        </div>
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    parent: true,
    filters: {
    },

    data: () => ({
      transactions: [],
      loadingTransactions: false,
      total: 0,
      filter: '',
      pagination: {
        page: 1,
        pageSize: 50,
        sortField: 'nameOnCard',
        sortOrder: 'desc',
      },
    }),


    watch: {
      pagination: {
        handler() {
          this.getTransactionsPaged();
        },
        deep: true,
      },
      filter() {
        this.getTransactionsPaged();
      },
    },

    mounted() {
      this.getTransactionsPaged();
    },
    methods: {
      async getTransactionsPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingTransactions = true;
        const { data } = await axios.get(`/admin/transactions/transactions-listing?${params}`);
        this.transactions = data.resultItems;
        this.total = data.totalRecords;
        this.loadingTransactions = false;
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },

      getStatusColor(status) {
        switch (status) {
          case 'Cancelled':
            return 'error';
          case 'Manually Entered':
            return 'gray-500';
          case 'Success':
            return 'green-500';
          default:
            return 'blue-500';
        }
      },

      getFriendlyTypeName(rawType) {
        switch (rawType) {
          case 'PROJECT_CERTIFICATION':
            return 'Project Certifiation';
          case 'APPLY':
            return 'Licensing Application';
          case 'DRAFTER_APPLY':
            return 'Drafter Application';
          case 'RENEWAL':
            return 'Renewal';
          default:
            return rawType;
        }
      },
    },
  };
</script>
